import { render, staticRenderFns } from "./OneColumn.vue?vue&type=template&id=22b0b26a&"
import script from "./OneColumn.vue?vue&type=script&lang=js&"
export * from "./OneColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
